// scroll page to Section
export const scrollToSection = (id, page) => {
  const element = document.getElementById(id);
  if (element) {
    const offset = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: page === 'developer' ? offset -200 : offset - 100, behavior: "smooth" });
  }
};
